import React from "react";
import * as Texts from "src/shared/components/Texts";

const SmileChangePlanSubtitle = ({ text }: { text: string }) => {
  return <Texts.NormalBold>{text}</Texts.NormalBold>;
};

export default SmileChangePlanSubtitle;
